"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var ReservedParameterError = /*#__PURE__*/function (_Error) {
  function ReservedParameterError(validationTitle, paramNames) {
    var _this;
    _classCallCheck(this, ReservedParameterError);
    var message = paramNames.length === 1 ? "".concat(paramNames, " is a ").concat(validationTitle, ".") : "[".concat(paramNames, "] are ").concat(validationTitle, "s.");
    _this = _callSuper(this, ReservedParameterError, [message]);
    _this.name = _this.constructor.name;
    return _this;
  }
  _inherits(ReservedParameterError, _Error);
  return _createClass(ReservedParameterError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
var MissingMandatoryParamError = /*#__PURE__*/function (_Error2) {
  function MissingMandatoryParamError(params) {
    _classCallCheck(this, MissingMandatoryParamError);
    return _callSuper(this, MissingMandatoryParamError, ["Missing params - {".concat(params, "}")]);
  }
  _inherits(MissingMandatoryParamError, _Error2);
  return _createClass(MissingMandatoryParamError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
var UnknownModuleError = /*#__PURE__*/function (_Error3) {
  function UnknownModuleError(module) {
    _classCallCheck(this, UnknownModuleError);
    return _callSuper(this, UnknownModuleError, ["The passed module - ".concat(module, " is invalid")]);
  }
  _inherits(UnknownModuleError, _Error3);
  return _createClass(UnknownModuleError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
var InvalidPageError = /*#__PURE__*/function (_Error4) {
  function InvalidPageError(page) {
    _classCallCheck(this, InvalidPageError);
    return _callSuper(this, InvalidPageError, ["The passed page - ".concat(page, " is invalid")]);
  }
  _inherits(InvalidPageError, _Error4);
  return _createClass(InvalidPageError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
var InvalidIdError = /*#__PURE__*/function (_Error5) {
  function InvalidIdError(id) {
    _classCallCheck(this, InvalidIdError);
    return _callSuper(this, InvalidIdError, ["The passed id - ".concat(id, " is invalid")]);
  }
  _inherits(InvalidIdError, _Error5);
  return _createClass(InvalidIdError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
var InvalidVersionError = /*#__PURE__*/function (_Error6) {
  function InvalidVersionError(version) {
    _classCallCheck(this, InvalidVersionError);
    return _callSuper(this, InvalidVersionError, ["The passed version - ".concat(version, " is invalid")]);
  }
  _inherits(InvalidVersionError, _Error6);
  return _createClass(InvalidVersionError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
var InvalidRevisionError = /*#__PURE__*/function (_Error7) {
  function InvalidRevisionError(revision) {
    _classCallCheck(this, InvalidRevisionError);
    return _callSuper(this, InvalidRevisionError, ["The passed revision - ".concat(revision, " is invalid")]);
  }
  _inherits(InvalidRevisionError, _Error7);
  return _createClass(InvalidRevisionError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
var InvalidContentTypeError = /*#__PURE__*/function (_Error8) {
  function InvalidContentTypeError(contentType) {
    _classCallCheck(this, InvalidContentTypeError);
    return _callSuper(this, InvalidContentTypeError, ["The passed contentType - ".concat(contentType, " is invalid")]);
  }
  _inherits(InvalidContentTypeError, _Error8);
  return _createClass(InvalidContentTypeError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
var InvalidBranchError = /*#__PURE__*/function (_Error9) {
  function InvalidBranchError(branch) {
    _classCallCheck(this, InvalidBranchError);
    return _callSuper(this, InvalidBranchError, ["The passed branch - ".concat(branch, " is invalid")]);
  }
  _inherits(InvalidBranchError, _Error9);
  return _createClass(InvalidBranchError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
var InvalidCommonConfigError = /*#__PURE__*/function (_Error0) {
  function InvalidCommonConfigError(commonConfig) {
    _classCallCheck(this, InvalidCommonConfigError);
    return _callSuper(this, InvalidCommonConfigError, ["The passed commonConfig - ".concat(commonConfig, " is invalid")]);
  }
  _inherits(InvalidCommonConfigError, _Error0);
  return _createClass(InvalidCommonConfigError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
module.exports = {
  ReservedParameterError: ReservedParameterError,
  MissingMandatoryParamError: MissingMandatoryParamError,
  UnknownModuleError: UnknownModuleError,
  InvalidPageError: InvalidPageError,
  InvalidIdError: InvalidIdError,
  InvalidVersionError: InvalidVersionError,
  InvalidRevisionError: InvalidRevisionError,
  InvalidContentTypeError: InvalidContentTypeError,
  InvalidBranchError: InvalidBranchError,
  InvalidCommonConfigError: InvalidCommonConfigError
};
//# sourceMappingURL=errors.js.map